import { render } from "./leave-report.vue?vue&type=template&id=64043f7b"
import script from "./leave-report.vue?vue&type=script&lang=js"
export * from "./leave-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__